import React from 'react';
import { Box, Button } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import SaveIcon from '@material-ui/icons/Save';

interface Props {
  onClearFields: () => void;
  onCreateProduct: () => void;
  isLoading?: boolean;
}

const component = ({ onClearFields, onCreateProduct, isLoading }: Props) => {
  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Button
        startIcon={<ClearIcon />}
        onClick={onClearFields}
        color="secondary"
        variant="contained"
        disabled={isLoading}
      >
        Clear
      </Button>
      <Button
        startIcon={<SaveIcon />}
        style={{ marginLeft: 18 }}
        onClick={onCreateProduct}
        color="primary"
        variant="contained"
        disabled={isLoading}
      >
        Save details
      </Button>
    </Box>
  );
};

export const AddProductFooterButtons = React.memo(component);
